import React from 'react'
import { Button, CircularProgress, ButtonProps, IconButton } from '@mui/material'
import { ApiState } from '../../utils/requestAction'
import { ErrorLabel } from './ShowLabel'

interface ProgressButtonProps {
  state: ApiState,
  disabled?: boolean,
}

export const IconProgressButton: React.FC<ProgressButtonProps & ButtonProps> = ({ state, disabled = false, children, ...props }) => {
  return (
    <div style={{...props.style}}>
      <IconButton
        variant="contained"
        color="primary"
        //size="medium"
        type="submit"
        //sx={{ textTransform:"none", borderRadius: '8px' }}
        disabled={!state.didInvalidate && (state.isFetching || disabled)}
        {...props}
      >
      {children}
      </IconButton>
      {state.isFetching && <CircularProgress size={24}/>}
      <ErrorLabel //TODO: Usar Alert
        show={state.didInvalidate}
        message={state.error ? state.error.message : ""}
      />
    </div>
  )
}

const ProgressButton: React.FC<ProgressButtonProps & ButtonProps> = ({ state, disabled = false, children, ...props }) => {
  return (
    <div style={{...props.style}}>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        sx={{ textTransform:"none", borderRadius: '8px' }}
        disabled={!state.didInvalidate && (state.isFetching || disabled)}
        {...props}
      >
      {children}
      </Button>
      {state.isFetching && <CircularProgress size={24}/>}
      <ErrorLabel //TODO: Usar Alert
        show={state.didInvalidate}
        message={state.error ? state.error.message : ""}
      />
    </div>
  )
}

export default ProgressButton

